import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getUnitPelayanan() {
  const response = await http
    .getData(`/referensi/unit-pelayanan`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function getCaraKeluarList() {
  const response = await http
    .getData(`/referensi/cara-pulang/search`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function getHolidays() {
  const response = await http
    .getData("/referensi/libur-nasional")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getMorseFallScale() {
  const response = await http
    .getData("/referensi/morse-fall-scale")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getHumptyDumpty() {
  const response = await http.getData("/referensi/humpty-dumpty").catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function getNyeriNips() {
  const response = await http
    .getData("/referensi/kategori-nyeri/nips")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getNyeriFlacc() {
  const response = await http
    .getData("/referensi/kategori-nyeri/flacc")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getNyeriBps() {
  const response = await http
    .getData("/referensi/kategori-nyeri/bps")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getUnitPelayanan,
  getCaraKeluarList,
  getHolidays,
  getMorseFallScale,
  getHumptyDumpty,
  getNyeriNips,
  getNyeriFlacc,
  getNyeriBps
};
